import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { Dispatch } from 'redux';
import { getAppViewUser } from '../app/store/appViewSlice';
import React, { FC } from 'react';
import { Routes } from '../routes';
import { RootState } from '../store';

type OwnProps = {
  children?: any;
};
type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps> &
  OwnProps;

const ProtectedRoute: FC<Props> = ({ user, children }) => {
  if (!user) {
    // user is not authenticated
    return <Navigate to={Routes.Login} />;
  }
  return children;
};

const mapStateToProps = (state: RootState) => ({
  user: getAppViewUser(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  // toggleIsUserMenuOpen: () =>
  //     dispatch(appViewUpdateIsUserMenuOpen()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProtectedRoute);
